var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 60 60",
    id: "Capa_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.554,0H37H23H10.446L0,16.713V60h23h14h23V16.713L49.554,0z M48.446,2l8.75,14H37V2H48.446z M30,2h5v14h-5h-5V2H30z    M25,18h1c0,0.552,0.448,1,1,1s1-0.448,1-1h4c0,0.552,0.448,1,1,1s1-0.448,1-1h1v3.586l-1-1l-4,4l-4-4l-1,1V18z M11.554,2H23v14   H2.804L11.554,2z M25,58v-2.586l1,1l4-4l4,4l1-1V58H25z M37,58v-7.414l-3,3l-4-4l-4,4l-3-3V58H2V18h21v8.414l3-3l4,4l4-4l3,3V18h21   v40H37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,48h20V30H20V48z M22,32h16v14H22V32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,42h-6c-0.552,0-1,0.447-1,1s0.448,1,1,1h6c0.552,0,1-0.447,1-1S31.552,42,31,42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,42h-1c-0.552,0-1,0.447-1,1s0.448,1,1,1h1c0.552,0,1-0.447,1-1S35.552,42,35,42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,34h-6c-0.552,0-1,0.447-1,1s0.448,1,1,1h6c0.552,0,1-0.447,1-1S35.552,34,35,34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,38h-2c-0.552,0-1,0.447-1,1s0.448,1,1,1h2c0.552,0,1-0.447,1-1S35.552,38,35,38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,40h2c0.552,0,1-0.447,1-1s-0.448-1-1-1h-2c-0.552,0-1,0.447-1,1S24.448,40,25,40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,36h1c0.552,0,1-0.447,1-1s-0.448-1-1-1h-1c-0.552,0-1,0.447-1,1S24.448,36,25,36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.71,39.71C30.89,39.52,31,39.26,31,39s-0.11-0.521-0.29-0.71c-0.38-0.37-1.05-0.37-1.42,0C29.11,38.479,29,38.729,29,39   c0,0.27,0.11,0.52,0.29,0.71C29.48,39.89,29.74,40,30,40C30.26,40,30.52,39.89,30.71,39.71z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 3,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 21,
    r: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.80fc5e295c4f92d05c3f9a2b4549f955.svg";
export { ForwardRef as ReactComponent };